import { render, staticRenderFns } from "./Sixmwt.vue?vue&type=template&id=24e28116&scoped=true"
import script from "./Sixmwt.vue?vue&type=script&lang=js"
export * from "./Sixmwt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e28116",
  null
  
)

export default component.exports